<script>
import HamletTable from "@core/components/common/HamletTable.vue";
import {BFormCheckbox, BFormInput, BFormRadioGroup} from 'bootstrap-vue'

export default {
    components: {HamletTable, BFormCheckbox, BFormInput, BFormRadioGroup},
    props: {
        borderVariant: {
            default: ''
        },
        properties: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default() {
                return this.$t('Component(RegulatedProductStatementDeclaration):label')
            },
        },
        selectionMode: {
            type: String,
            default: 'switch',
            validator(value) {
                return ['switch', 'radio'].includes(value);
            },
        },
        showComment: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            config: null,
            fetchCallback: null,
            answerOptions: [
                {text: this.$t('Component(Choice):yes'), value: true},
                {text: this.$t('Component(Choice):no'), value: false},
                {text: this.$t('Component(Choice):not_answered'), value: null},
            ],
            baseColumns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                },
                {
                    key: 'coveredExcluded',
                    label: this.$t('Component(Grid):column-covered-excluded'),
                },
            ]
        }
    },
    computed: {
        columns() {
            const columns = [...this.baseColumns];
            if (this.showComment) {
                columns.push({
                    key: 'comment',
                    label: this.$t('Component(Label):comment'),
                });
            }
            return columns;
        },
    },
    methods: {
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;

            cb(
                this.properties.length,
                this.properties.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb) {
            this.config = config;
            this.fetchCallback = cb;
        },
        emitChange() {
            this.$emit('change', this.properties);
        },
    },
    watch: {
        properties() {
            this.fetch(this.config, this.fetchCallback);
        }
    }
}
</script>

<template>
    <div>
        <HamletTable
            :border-variant="borderVariant"
            :columns="columns"
            :fetch="fetch"
            :show-paging-when-empty="false"
            :show-empty-message="false"
            @created="onTableCreated"
        >
            <template #header-label>
                {{ title }}
            </template>

            <template #cell-title="data">
                {{ data.item.statement.title }}
            </template>

            <template #cell-coveredExcluded="data">
                <b-form-radio-group
                    v-if="selectionMode === 'radio'"
                    v-model="data.item.coveredExcluded"
                    :options="answerOptions"
                    class="d-inline-flex"
                    @change="emitChange"
                />
                <b-form-checkbox
                    v-else
                    inline
                    switch
                    class="text-center"
                    v-model="data.item.coveredExcluded"
                    @change="emitChange"
                />
            </template>

            <template #cell-comment="data">
                <b-form-input
                    v-model="data.item.comment"
                    :placeholder="$t('Component(Label):comment')"
                    @input="emitChange"
                />
            </template>
        </HamletTable>
    </div>
</template>
